import React, { useEffect, useState } from 'react'
import ModalTest from '../../../BaseModal'
import { Button, ButtonContainer, CloseDiv, ContainerOfModal, Header, HeaderTitle, ViewContainer, ViewItem } from '../../../styles/modal-style'
import { useNavigate, useSearchParams } from 'react-router-dom'
import axios from 'axios'
import { X } from 'lucide-react'
import { Label } from '../../../styles/select-style'
import editPen from '../../../../assets/certificates/Tables/pencil.svg'

interface Supplier {
  id: number
  companyName: string
}

interface Resource {
  id: number
  name: string
  category: string
  type: string
  pricePerUnit: string
  suppliers: Supplier[]
}

const ViewResourceModal = () => {
  const [ searchParams ] = useSearchParams()
  const id = searchParams.get('id')
  const navigate = useNavigate()
  const [ resource, setResource ] = useState<Resource | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_RESOURCES_BASE_URL}/resource/${id}`)
          const data = response.data
          setResource(data)
        } catch (error) {
          console.log(error)
        }
      }
    }
    fetchData()
  }, [id])

  return (
    <ModalTest>
      <ContainerOfModal width='800px'>
        <Header>
          <HeaderTitle>Insumo: {resource?.name}</HeaderTitle>
          <CloseDiv onClick={() => navigate('..')}> <X size={20} /></CloseDiv>
        </Header>        
        <ViewContainer>
          <ViewItem>
            <span>Categoria</span>
            <Label>{resource?.category}</Label>
          </ViewItem>
          <ViewItem>
            <span>Tipo</span>
            <Label>{resource?.type}</Label>
          </ViewItem>
          <ViewItem>
            <span>Preço/un</span>
            <Label>R$ {resource?.pricePerUnit}</Label>
          </ViewItem>
          <ViewItem>
            <span>Fornecedores</span>
            <Label>{resource?.suppliers.map((supplier: any) => supplier.companyName).join(', ')}</Label>
          </ViewItem>
        </ViewContainer>
        <ButtonContainer>
          <Button 
            onClick={() => navigate(`/panel/resource/edit/?id=${id}`)}
            className='cancel'><img src={editPen} alt='cancel' /> Editar</Button>
        </ButtonContainer>
      </ContainerOfModal>
    </ModalTest>
  )
}

export default ViewResourceModal